import { Routes } from '@angular/router';
import { AuthErrorComponent } from './components/auth-error/auth-error.component';

export const authRoutes: Routes = [
  {
    path: 'unauthorized',
    component: AuthErrorComponent,
    data: { title: 'auth.unauthorized.title', message: 'auth.unauthorized.message' },
  },
  {
    path: 'maintenance',
    component: AuthErrorComponent,
    data: { title: 'auth.maintenance.title', message: 'auth.maintenance.message' },
  },
  { path: 'error', component: AuthErrorComponent, data: { title: 'auth.error.title', message: 'auth.error.message' } },
];
